export const trimString = (element, stingLength) => {
  if (element.length) {
    element.forEach(function (element) {
      let text = element.innerText;
      let textLength = text.length;
      if (textLength > stingLength) {
        text = `${text.slice(0, stingLength)} ...`;
        element.innerText = text
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/exports/trimString.js